import {
  BarChartOutlined,
  BlockOutlined,
  CalculatorOutlined,
  FundOutlined,
  GiftOutlined,
  GlobalOutlined,
  HomeOutlined,
  MoneyCollectOutlined,
  SettingOutlined,
  SolutionOutlined,
  TeamOutlined,
} from '@ant-design/icons-vue';
import { array2Object } from '@bigo/helpers';
import { FunctionalComponent } from 'vue';

export type MenuItem = {
  /** ID */
  id: string;
  /** 📈 */
  icon?: FunctionalComponent;
  /** 名称 */
  name: string;
  /** 子菜单 */
  children?: MenuItem[];
};

// FIXME: 后端没有定义首页权限
export const homeMenuItem = {
  id: 'home',
  icon: HomeOutlined,
  name: '首页',
};

export enum MenuId {
  dataChart = 'dataChart',
  budgetTotalApply = 'budgetTotalApply',
  budgetExpendBalance = 'budgetExpendBalance',
  budgetExpendNumber = 'budgetExpendNumber',
  businessUser = 'businessUser',
  financeSubject = 'financeSubject',
  regionsConfig = 'regionsConfig',
  activityMiddleground = 'activityMiddleground',
  autoAwardBudget = 'autoAwardBudget',
  productAuthority = 'productAuthority',
  systemAuthority = 'systemAuthority',
}

const menu: MenuItem[] = [
  {
    id: MenuId.dataChart,
    icon: BarChartOutlined,
    name: '预算管理报表',
  },
  {
    id: MenuId.budgetTotalApply,
    icon: CalculatorOutlined,
    name: '预算总额申请管理',
  },
  {
    id: MenuId.budgetExpendBalance,
    icon: CalculatorOutlined,
    name: '预算总额支出管理',
  },
  {
    id: MenuId.budgetExpendNumber,
    icon: FundOutlined,
    name: '预算编号管理',
  },
  {
    id: MenuId.businessUser,
    icon: TeamOutlined,
    name: '预算业务负责人管理',
  },
  {
    id: MenuId.financeSubject,
    icon: BlockOutlined,
    name: '财务科目管理',
  },
  {
    id: MenuId.regionsConfig,
    icon: GlobalOutlined,
    name: '国家地区关系配置',
  },
  {
    id: MenuId.activityMiddleground,
    icon: GiftOutlined,
    name: '活动中台管理',
  },
  {
    id: MenuId.autoAwardBudget,
    icon: MoneyCollectOutlined,
    name: '自动发奖预算管理',
  },
  {
    id: MenuId.productAuthority,
    icon: SolutionOutlined,
    name: '业务权限管理',
  },
  {
    id: MenuId.systemAuthority,
    icon: SettingOutlined,
    name: '系统权限管理',
  },
];

export const menuMap = array2Object(menu, 'id');

export const getMenuName = (id: string) => menuMap[id]?.name;

export default menu;
